import clsx from 'clsx'
import React, { useState } from 'react'

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tooltipText?: string
  clickedText?: string
  onClick?: () => void
  className?: string
  containerClassName?: string
  tooltipClassName?: string
}

export function IconButton({
  children,
  tooltipText,
  clickedText,
  onClick,
  className = '',
  containerClassName = '',
  tooltipClassName = '',
  ...props
}: React.PropsWithChildren<IconButtonProps>) {
  const [isClicked, setIsClicked] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = ev => {
    ev.preventDefault()
    ev.stopPropagation()
    setIsClicked(true)
    onClick?.()

    // Reset the clicked state after 2 seconds
    setTimeout(() => {
      setIsClicked(false)
    }, 2000)
  }

  return (
    <div className={clsx('relative inline-block', containerClassName)}>
      <button
        {...props}
        className={clsx(
          'p-2 rounded hover:bg-gray-100/20 transition-colors',
          className,
        )}
        onClick={handleClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {children}
      </button>

      {(showTooltip || (isClicked && clickedText)) && (
        <div
          className={clsx(
            'absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2',
            tooltipClassName,
          )}
        >
          <div className="px-3 py-1.5 text-xs text-black bg-white rounded whitespace-nowrap shadow-lg border border-gray-200 relative">
            {isClicked && clickedText ? clickedText : tooltipText}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-white"></div>
          </div>
        </div>
      )}
    </div>
  )
}
